<style lang="stylus">
        .main-page
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            background-color #f8f9fa
            z-index 999
            .container
                padding 0px 24px
                background-color #f8f9fa
                height 100%
                .mp-container
                    display flex
                    flex-direction column
                    max-width 1647px
                    margin 0 auto
                    top 0
                    .mp-Topbar
                        width 100%
                        height 60px
                        background-color #f8f9fa
                        display flex
                        align-items center
                        font-size 16px
                        cursor pointer
                        z-index 2
                        position fixed
                        svg
                            width 10px
                            height 16px
                            margin-right 16px
                    .mp-container-content
                        display flex
                        margin-top 60px
            .mp-loading
                position absolute
                top 0
                left 0
                width 100%
                height 100%
                min-height 460px
                display flex
                justify-content center
                align-items center
                background #f8f9fa
                z-index 1
                img
                    width 250px

        div,p,ul,li
            margin 0
            padding 0
            box-sizing border-box

        a
            text-decoration none
        ul, li
            list-style none
    .main-page.dark-theme__workbench
        background-color #222222
        .container
            background-color #222222
            .mp-container
                .mp-Topbar
                    background-color #222222
                    color #fff
                    svg
                        fill #fff
        .mp-loading
            background-color #222222
</style>

<template>
    <div class="main-page" :class="{ 'dark-theme__workbench': isPCDarkMode == 2 }" :style="pcFitWidth">
        <div class="container" v-if="!loading">
            <div class="mp-container">
                <div class="mp-Topbar">
                    <div @click="toshowUserWorks">
                        <iconSymbol name="template-back" />
                        <span>{{ $t("back") }}</span>
                    </div>
                </div>
                <div class="mp-container-content">
                    <UserArea :style="{ position: !isfixed ? 'relative' : 'fixed' }" />
                    <WorksArea :style="{ 'margin-left': !isfixed ? '24px' : '291px' }" :isfixed="isfixed" />
                </div>
            </div>
        </div>

        <div class="mp-loading" v-if="loading">
            <img :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
            <!-- <div :style="{background: `url(${require('@/home/assets/img/loading.svg')})`,height: '40px',width: '40px'}"></div> -->
        </div>
        <EditUserInfo />
        <EditUserInfoAvatorImg />
    </div>
</template>

<script>
    import UserArea from "./userArea.vue";
    import WorksArea from "./worksArea.vue";
    import EditUserInfo from "./editUserInfo.vue";
    import EditUserInfoAvatorImg from "./editUserInfoAvatorImg.vue";
    export default {
        name: "MainPage",
        data() {
            return {
                selIndex: 0,
                doingCollect: false,
                doingLike: false,
                eventFrom: "",
                loading: true,
                isfixed: false,
            };
        },
        computed: {
            visitUser() {
                return this.$store.state.tplCenter.visitUser;
            },
            visitUserId() {
                return this.$store.state.tplCenter.visitUser.id;
            },
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            likeIds() {
                return this.$store.state.userPage.likeIds;
            },
            collectIds() {
                return this.$store.state.userPage.collectIds;
            },
            clickUserWordIds() {
                return this.$store.state.userPage.clickUserWordIds;
            },
            showUserWorks() {
                return this.$store.state.tplCenter.showUserWorks;
            },
            pcFitWidth() {
                if (this.isPC && this.$route.name == "Collect") {
                    return {
                        left: `${this.$store.state.pcSliderFitWidth}px`,
                    };
                }
                return "";
            },
        },
        components: {
            UserArea,
            WorksArea,
            EditUserInfo,
            EditUserInfoAvatorImg,
        },
        props: {},
        watch: {
            visitUserId: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$bus.$emit("reloadUser");
                }
            },
        },
        methods: {
            containerScrollEvent() {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 0) {
                    this.isfixed = true;
                } else {
                    this.isfixed = false;
                }
            },
            toshowUserWorks() {
                let len = this.clickUserWordIds.length;
                console.log("clickUserWordIds", this.clickUserWordIds);
                if (len <= 1) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    this.$store.commit("userPage/disClickUserWordId", {
                        start: 0,
                        num: len,
                    });
                    console.log("showUserWorks", this.$store.state.showUserWorks);
                } else {
                    this.$store.commit("toVisitUser", {
                        id: this.clickUserWordIds[len - 2],
                    });
                    this.$bus.$emit("reloadUser");
                    this.$store.commit("userPage/disClickUserWordId", {
                        start: len - 1,
                        num: 2,
                    });
                }
            },
            initData() {
                let prm = [];
                this.$store.commit("userPage/setState", {
                    type: "viewerID",
                    data: this.visitUser.id,
                });
                let len = this.clickUserWordIds.length;
                if ((len >= 1 && this.clickUserWordIds[len - 1] != this.visitUser.id) || len == 0) {
                    this.$store.commit("userPage/clickUserWordId", this.visitUser.id);
                }
                prm.push(this.$store.dispatch("userPage/getIntervieweeUserInfo"));
                prm.push(this.$store.dispatch("userPage/getIntervieweePublish"));
                prm.push(this.$store.dispatch("userPage/getIntervieweeHotData"));
                prm.push(this.$store.dispatch("userPage/getIntervieweeCollect"));
                prm.push(this.$store.dispatch("userPage/getRelationships"));
                // 需登录态
                this.$store.commit("userPage/toUserInfo", JSON.parse(JSON.stringify(this.userInfo)));
                prm.push(this.$store.dispatch("userPage/getViewerFollowIDs"));
                return Promise.all(prm);
            },
            //点赞或取消赞
            like(id, from) {
                if (!this.userInfo.islogin) {
                    this.$showLogin();
                    return;
                }
                if (this.doingLike) return;
                this.doingLike = true;
                if (this.likeIds.indexOf(id) == -1) {
                    //点赞
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(this.params, {
                                workId: id,
                                like: 1,
                            })
                        )
                        .then((res) => {
                            this.updateWorkData({ id, type: "like" });
                            from !== "tplpreview" && this.updateStoreData({ id, type: "like" }); // 预览页面传递的动作不需要更新外部数据
                            this.doingLike = false;
                        });
                } else {
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(this.params, {
                                workId: id,
                                like: 0,
                            })
                        )
                        .then(() => {
                            this.updateWorkData({ id, type: "dislike" });
                            from !== "tplpreview" && this.updateStoreData({ id, type: "dislike" });
                            this.doingLike = false;
                        });
                }
            },
            //收藏或取消收藏
            collect(id, from) {
                if (!this.userInfo.islogin) {
                    this.$showLogin();
                    return;
                }
                if (this.doingCollect) return;
                this.doingCollect = true;
                if (this.collectIds.indexOf(id) == -1) {
                    // 收藏
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(this.params, {
                                workId: id,
                                collect: 1,
                            })
                        )
                        .then(() => {
                            this.updateWorkData({ id, type: "collect" });
                            from !== "tplpreview" && this.updateStoreData({ id, type: "collect" });
                            this.doingCollect = false;
                        });
                } else {
                    // 取消收藏
                    this.$edApi
                        .likeOrCollectWork(
                            Object.assign(this.params, {
                                workId: id,
                                collect: 0,
                            })
                        )
                        .then(() => {
                            this.updateWorkData({ id, type: "discollect" });
                            from !== "tplpreview" && this.updateStoreData({ id, type: "discollect" });
                            this.doingCollect = false;
                        });
                }
            },
            updateWorkData(args) {
                let { id, type } = args;
                switch (type) {
                    case "like": {
                        this.$store.commit("userPage/like", {
                            id,
                            from: this.eventFrom,
                        });
                        this.$bus.$emit("updateHotData", 1);

                        if (!this.isViewer) {
                            this.$store.dispatch("userPage/getIntervieweeLikeWorks").then((e) => {
                                this.$bus.$emit("reloadLike");
                            });
                        }
                        break;
                    }
                    case "dislike": {
                        this.$store.commit("userPage/dislike", {
                            id,
                            from: this.eventFrom,
                        });
                        this.$bus.$emit("updateHotData", 1);
                        if (!this.isViewer) {
                            this.$store.dispatch("userPage/getIntervieweeLikeWorks").then((e) => {
                                this.$bus.$emit("reloadLike");
                            });
                        }
                        break;
                    }
                    case "collect": {
                        this.$store.commit("userPage/collect", {
                            id,
                            from: this.eventFrom,
                        });
                        this.$bus.$emit("updateHotData", 3);
                        // 用户本人取消收藏时刷新本页数据
                        if (!this.isViewer) {
                            this.$store.dispatch("userPage/getIntervieweeCollectByPage", this.$store.state.userPage.collectCurrent).then((e) => {
                                this.$bus.$emit("reloadCollect");
                            });
                        }
                        break;
                    }
                    case "discollect": {
                        this.$store.commit("userPage/disCollect", {
                            id,
                            from: this.eventFrom,
                        });
                        this.$bus.$emit("updateHotData", 3);
                        // 用户本人取消收藏时刷新本页数据
                        if (!this.isViewer) {
                            this.$store.dispatch("userPage/getIntervieweeCollectByPage", this.$store.state.userPage.collectCurrent).then((e) => {
                                this.$bus.$emit("reloadCollect");
                            });
                        }
                        break;
                    }
                }
            },
            updateStoreData(data) {
                // 更新社区信息
                this.$bus.$emit("updateWorkIds", data);
                this.$bus.$emit("updateWorkIds2", data);
            },
        },
        mounted() {
            this.initData().then(() => {
                this.loading = false;
            });
            window.addEventListener("scroll", this.containerScrollEvent);
        },
        created() {
            this.$bus.$on("reloadUser", () => {
                this.loading = true;
                this.initData().then(() => {
                    this.loading = false;
                });
            });

            this.$bus.$on("actionToWork", (payload) => {
                if (!this.$validateLogin()) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    return;
                }
                this.eventFrom = payload.from;
                switch (payload.type) {
                    case "like": {
                        this.like(payload.id, payload.from);
                        break;
                    }
                    case "collect": {
                        this.collect(payload.id, payload.from);
                        break;
                    }
                }
            });
        },
        beforeDestroy() {
            this.$bus.$off("reloadUser");
            this.$bus.$off("actionToWork");
            window.removeEventListener("scroll", this.containerScrollEvent);
        },
    };
</script>

<i18n>
{
  "zh": {
    "back": "返回"
  },
  "en": {
    "back": "返回"
  },
  "fr": {
    "back": "返回"
  },
  "de": {
    "back": "返回 "
  },
  "jp": {
    "back": "返回"
  },
  "es": {
    "back": "返回"
  },
  "pt": {
    "back": "返回"
  },
  "it": {
    "back": "返回"
  },
  "tw": {
    "back": "返回"
  },
  "kr": {
    "back": "返回"
  },
  "id": {
    "back": "返回"
  }
}
</i18n>
